import { TransparentRow } from './Row';
import { TextTag } from './StyledText';

export default function SmallTag({
  title,
  color = '#FEEB73',
  textColor = '#000',
}: {
  title: string;
  color?: string;
  textColor?: string;
}) {
  return (
    <TransparentRow
      style={{
        height: 20,
        borderRadius: 10,
        paddingHorizontal: 10,
        backgroundColor: color,
      }}
    >
      <TextTag style={{ color: textColor }}>{title}</TextTag>
    </TransparentRow>
  );
}
